import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DetailedSkinAnalysisComponent } from '../detailed-skin-analysis/detailed-skin-analysis.component';
import { CommonModule } from '@angular/common';
import { DetailedEyeAnalysisComponent } from '../detailed-eye-analysis/detailed-eye-analysis.component';
import {
  transformName,
  getSeverityColor,
  getSeverityDashOffset,
  getSeverityValue,
  transformSeverityForDisplay,
} from '../../../utils/severity.utils';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { RtlService } from '../../services/rtl.service';

@Component({
  selector: 'app-biomarker-card',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './biomarker-card.component.html',
  styleUrls: ['./biomarker-card.component.scss'],
})
export class BiomarkerCardComponent {
  dialog = inject(MatDialog);
  @Input() data: any;
  @Input() type: string;

  constructor(public rtlService: RtlService) {}

  openEyeDialog() {
    this.dialog.open(DetailedEyeAnalysisComponent, {
      data: this.data,
      panelClass: 'custom-container',
    });
  }

  openSkinAnalysisDialog() {
    this.dialog.open(DetailedSkinAnalysisComponent, {
      data: this.data,
      panelClass: 'custom-container',
    });
  }

  transformName = transformName;

  openDialog(type: string) {
    if (type == 'eye_analysis') {
      this.openEyeDialog();
    } else {
      this.openSkinAnalysisDialog();
    }
  }

  getSeverityColor = getSeverityColor;
  getSeverityDashOffset = getSeverityDashOffset;
  getSeverityValue = getSeverityValue;

  getSeverityDisplayText(severity: string): string {
    return transformSeverityForDisplay(severity);
  }
}
